<template lang="pug">
    .page
        img.banner(:src="img")
        .content-container
            .title 关于我们
            .content(v-html="content")
</template>

<script>
import axios from 'axios'

export default {
    name: 'Company',
    data() {
        return {
            content: '',
            img: ''
        }
    },
    created() {
        axios.get('/api/about').then(res => {
            this.content = res.data.content
            this.img = res.data.img
        })
    }
}
</script>

<style lang="sass" scoped>
.page
    width: 100%
    padding-top: 60px
    .banner
        width: 100%
    .content-container
        max-width: 1000px
        margin: 0 auto
        padding-top: 60px
        font-size: 16px
        line-height: 2
        padding: 60px
        .title
            font-size: 30px
            padding-left: 0.8em
            position: relative
            line-height: 1
            margin-bottom: 30px
            &::before
                content: ''
                display: block
                height: 1em
                width: 4px
                background: #c40000
                position: absolute
                top: 0
                left: 0
        .sub-title
            font-weight: 500
        .content
            margin-bottom: 50px
@media screen and (min-width: 1024px)
    .page
        width: 100%
        padding-top: 100px
        .banner
            width: 100%
        .content-container
            max-width: 1000px
            margin: 0 auto
            padding-top: 60px
            font-size: 16px
            line-height: 2
            .title
                font-size: 30px
                padding-left: 0.8em
                position: relative
                line-height: 1
                margin-bottom: 30px
                &::before
                    content: ''
                    display: block
                    height: 1em
                    width: 4px
                    background: #c40000
                    position: absolute
                    top: 0
                    left: 0
            .sub-title
                font-weight: 500
            .content
                margin-bottom: 50px
</style>